import { CircleCheckBig } from "lucide-react";
import Avatar from "../common/Avatar";
import RankBadge from "./RankBadge";

const fmt = (iso) =>
  new Date(iso).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

export default function RankCertificate({ profile }) {
  const { rank_history = [] } = profile;

  return (
    <div className="certificate-frame max-w-2xl mx-auto bg-white rounded-lg shadow-card">
      {/* Double-border frame */}
      <div className="border-4 border-stone/60 rounded-lg">
        <div className="border-2 border-terracotta/70 rounded-sm p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="font-display text-xl tracking-wider text-terracotta mb-1">
              Good Place
            </h1>
            <p className="text-xs uppercase tracking-[0.2em] text-walnut-light font-medium">
              Community Rank Certificate
            </p>
            <div className="mt-4 border-t border-terracotta/30" />
          </div>

          {/* Recipient */}
          <div className="text-center mb-10">
            <p className="italic text-sm text-walnut-light mb-4">
              This certifies that
            </p>
            <div className="flex justify-center mb-3">
              <Avatar user={profile} size="lg" />
            </div>
            <div className="flex items-center justify-center gap-2 mb-2">
              <span className="font-display text-3xl font-bold text-walnut">
                {profile.display_name}
              </span>
              {profile.is_verified && (
                <CircleCheckBig size={22} className="text-terracotta" />
              )}
            </div>
            <p className="text-sm text-walnut-light mb-5">
              has achieved the rank of
            </p>
            <div className="inline-block transform scale-150 my-4">
              <RankBadge rank={profile.rank} />
            </div>
            <p className="text-sm font-semibold text-amber mt-6">
              {profile.community_points} Community Points
            </p>
          </div>

          {/* Rank History Timeline */}
          {rank_history.length > 0 && (
            <div className="mb-10">
              <h2 className="font-display text-lg font-semibold text-walnut mb-4 text-center">
                Rank Progression
              </h2>
              <div className="max-w-sm mx-auto space-y-4">
                {rank_history.map((rh, i) => (
                  <div key={i} className="flex items-center gap-4">
                    <div className="w-4 h-4 rounded-full bg-white border-2 border-terracotta flex-shrink-0" />
                    <RankBadge rank={rh.rank} />
                    <span className="text-sm text-walnut-light">
                      {fmt(rh.achieved_at)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Footer divider */}
          <div className="border-t border-terracotta/30 mb-6" />

          {/* Footer */}
          <div className="text-center space-y-1">
            <p className="text-xs text-walnut-light">
              Issued on {fmt(new Date().toISOString())}
            </p>
            {profile.created_at && (
              <p className="text-xs text-walnut-light">
                Member since {fmt(profile.created_at)}
              </p>
            )}
            <p className="text-xs font-medium text-stone tracking-wider mt-2">
              Good Place
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
